var Config = /** @class */ (function () {
    function Config() {
    }
    // public static domain: string = process.env.NODE_ENV === 'development' ?
    //     'https://notos.devzone.sirma.bg/' : window.location.origin + "/";
    Config.domain = 'https://api.prettyshop.bg/';
    Config.apiEndpoint = Config.domain + 'api/v1/';
    Config.tinyMCEKey = 'nwf03352wp9d4m6x6iktg8rohnqi098cknh5c542nt1yqnv4';
    Config.cdnDomain = 'https://cdn.prettyshop.bg/';
    return Config;
}());
export default Config;



//////////////////
// WEBPACK FOOTER
// ./src/config/config.ts
// module id = 17
// module chunks = 0